module Context

open Feliz
open Client.Types

let AppContext:Fable.React.IContext<AppContext> = React.createContext(name="AppContext")